/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import tick from "../../Assets/tick.png";
import party from "../../Assets/party.png";
import defaultImage from "../../../src/Assets/fallbackimg_giftcard.png";
import ScrollToTop from "../ScrollToTop/ScrollToTop";
import warning from "../../Assets/warning.png";
import { Link, useLocation } from "react-router-dom";
import Loader from "../../Components/Loader/Loader";
import pointiconImage from "../../../src/Assets/point_icon.svg";
import BackSections from "../Giftcards/BackSections";
import TncRedeemNoteBox from "../Common/TncRedeemNoteBox";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import {
  ClientConfigurationData,
  CardDataSlice,
  ClientInfo,
  Dispatch,
  formatPrice,
  GetOrderCodeReducer,
  LoginV3Data,
  useGaTrackingConfig,
  Navigate,
  trackEvent,
  getImageUrl,
} from "../Utility/Utility";
import {
  onSaveDenoCard,
  onSavePoints,
  onShowThankYouReset,
} from "../../Store/Slices/cardDataSlice";
import { callSwitchAccountApi } from "../../Context/switchAccountApi";
import ThankYouOrderDetails from "./ThankYouOrderDetails";
import { onGetOrderCode } from "../../Store/Slices/getOrderCodeSlice";
import { onProductByProductIdSubmit } from "../../Store/Slices/productSlice";
import { decryptAES } from "../../Common/Axios/encrypt";
import {
  getPointEarnStatus,
  getPointsRedeemStatus,
  isRewardStatusNotApplicable,
} from "../Utility/rewardStatus";
import { callSupplierMasterGetApi } from "../../Context/supplierMasterApi";

const isEnabledConfigValue = (value) =>
  value === true ||
  value === 1 ||
  ["1", "true", "active"].includes(String(value ?? "").trim().toLowerCase());

const getIdentifierType = (value) => {
  if (value === undefined || value === null || value === "") return 1002;
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
};

const hasNewOrderConfirmationStyles = () =>
  window
    .getComputedStyle(document.documentElement)
    .getPropertyValue("--order-confirmation-new-design")
    .trim() === "1";

const OrderConfirmation = () => {
  const translation = getTranslationData();
  const location = useLocation();
  const isMobile = window.innerWidth < 992;
  const cardData = CardDataSlice();
  const orderDetails = cardData?.OrderData;
  const earnedPoints = Math.max(0, Number(orderDetails?.earnPoints) || 0);
  const redeemedPoints = Math.max(0, Number(orderDetails?.burnPoints) || 0);
  const pointEarnStatus = getPointEarnStatus(location?.state, orderDetails);
  const pointsRedeemStatus = getPointsRedeemStatus(location?.state, orderDetails);
  const showEarnPointData = !isRewardStatusNotApplicable(pointEarnStatus);
  const showRedeemPointData = !isRewardStatusNotApplicable(pointsRedeemStatus);
  const productData = useSelector((state) => state?.productDataReducer);
  const cardListData = useSelector((state) => state.clientConfigDataReducer);
  const orderConfirmationProduct = useSelector(
    (state) => state.productReducer?.productByProductId?.[0],
  );
  const orderFailure =
    location?.state?.orderStatus &&
    location?.state?.orderStatus?.toLowerCase() === "failed";
  const categoryData = useSelector(
    (state) => state.userRoleSliceReducer.categoryData,
  );
  const clientConfig = ClientConfigurationData();
  const clientInfo = ClientInfo();
  const [useNewOrderConfirmation, setUseNewOrderConfirmation] = useState(
    hasNewOrderConfirmationStyles,
  );
  const clientConfigurations = clientInfo?.clientData?.clientConfigurations;
  const earnLabelConfig =
    clientConfig?.clientConfig?.find(
      (item) =>
        String(item?.configKey ?? "").trim().toLowerCase() ===
        "isearnlabelshowonly",
    )?.configValue ??
    clientConfig?.isEarnLabelShowOnly ??
    clientConfigurations?.find(
      (item) =>
        String(item?.configKey ?? "").trim().toLowerCase() ===
        "isearnlabelshowonly",
    )?.configValue;
  const journeyType = clientInfo?.clientData?.journeyType;
  const isWalletJourney =
    journeyType === true ||
    journeyType === 1 ||
    String(journeyType).trim().toLowerCase() === "true" ||
    String(journeyType).trim() === "1";
  const showEarnedPoints =
    showEarnPointData &&
    isEnabledConfigValue(earnLabelConfig) &&
    !isWalletJourney &&
    redeemedPoints === 0 &&
    earnedPoints > 0;
  const gaTrackingConfig = useGaTrackingConfig();
  const navigate = Navigate();
  const dispatch = Dispatch();
  const loginV3Data = LoginV3Data();
  const orderCodeData = GetOrderCodeReducer();
  const purchasedDenomination = orderDetails?.orderItems?.find(
    (item) => Number(item?.quantity) > 0,
  )?.denomination;
  const confirmationProductId =
    orderDetails?.orderItems?.find((item) => item?.productId)?.productId ||
    orderDetails?.id ||
    productData?.data?.id;
  const encryptedVoucherCodes = orderCodeData?.OrderCodeData?.[0]?.giftCode;
  const issuedVouchers = useMemo(() => {
    if (!encryptedVoucherCodes) return [];
    try {
      const decryptedCodes = decryptAES(encryptedVoucherCodes);
      return Array.isArray(decryptedCodes) ? decryptedCodes : [];
    } catch {
      return [];
    }
  }, [encryptedVoucherCodes]);
  const [supplierGcIdConfig, setSupplierGcIdConfig] = useState("");
  const orderCodeRecord = orderCodeData?.OrderCodeData?.[0] || {};
  const voucherSupplierCode =
    orderCodeRecord?.supplierCode ||
    orderCodeRecord?.SupplierCode ||
    issuedVouchers?.[0]?.supplierCode ||
    issuedVouchers?.[0]?.SupplierCode ||
    orderDetails?.supplierCode ||
    orderDetails?.SupplierCode ||
    productData?.data?.supplierCode ||
    orderConfirmationProduct?.supplierCode ||
    "";
  const tncComponent = (
    <TncRedeemNoteBox translation={translation} productData={productData} />
  );
  const newOrderTncComponent = (
    <TncRedeemNoteBox
      translation={translation}
      productData={productData}
      affiliateLink={orderConfirmationProduct?.affiliateLink}
      issuedVouchers={issuedVouchers}
      variant="bom-actions"
    />
  );

  useEffect(() => {
    if (
      useNewOrderConfirmation &&
      !orderFailure &&
      confirmationProductId
    ) {
      dispatch(onProductByProductIdSubmit(confirmationProductId));
    }
  }, [
    confirmationProductId,
    dispatch,
    orderFailure,
    useNewOrderConfirmation,
  ]);

  useEffect(() => {
    if (
      !useNewOrderConfirmation ||
      orderFailure ||
      supplierGcIdConfig ||
      issuedVouchers.length === 0
    ) return;

    let cancelled = false;
    const voucher = issuedVouchers[0];
    const supplierCodes = String(voucherSupplierCode)
      .split(",")
      .map((code) => code.trim().toLowerCase())
      .filter(Boolean);
    const hasVoucherValue = (fieldName) => {
      if (!fieldName || fieldName === "-") return false;
      const normalizedFieldName = String(fieldName)
        .replace(/[^a-z0-9]/gi, "")
        .toLowerCase();
      return Object.entries(voucher || {}).some(
        ([key, value]) =>
          key.replace(/[^a-z0-9]/gi, "").toLowerCase() === normalizedFieldName &&
          value !== null &&
          value !== undefined &&
          String(value).trim() !== "",
      );
    };

    const loadGcIdConfig = async () => {
      try {
        const supplierResponse = await callSupplierMasterGetApi();
        const suppliers = Array.isArray(supplierResponse?.response)
          ? supplierResponse.response
          : [];
        const matchingSuppliers = supplierCodes.length > 0
          ? suppliers.filter((supplier) =>
            supplierCodes.includes(String(supplier?.code || "").trim().toLowerCase()),
          )
          : suppliers;
        const supplier =
          matchingSuppliers.find((item) => hasVoucherValue(item?.gcIdConfig)) ||
          matchingSuppliers.find(
            (item) => item?.gcIdConfig && item.gcIdConfig !== "-",
          );

        if (!cancelled) setSupplierGcIdConfig(supplier?.gcIdConfig || "");
      } catch {
        if (!cancelled) setSupplierGcIdConfig("");
      }
    };

    loadGcIdConfig();
    return () => {
      cancelled = true;
    };
  }, [
    issuedVouchers,
    orderFailure,
    supplierGcIdConfig,
    useNewOrderConfirmation,
    voucherSupplierCode,
  ]);

  useEffect(() => {
    const syncOrderConfirmationDesign = () => {
      setUseNewOrderConfirmation(hasNewOrderConfirmationStyles());
    };
    const tenantTheme = document.getElementById("tenant-theme");

    syncOrderConfirmationDesign();
    tenantTheme?.addEventListener("load", syncOrderConfirmationDesign);

    return () => {
      tenantTheme?.removeEventListener("load", syncOrderConfirmationDesign);
    };
  }, []);
  const activeCardIdentifier = useSelector(
    (state) => state.cardDataSliceReducer?.subIdentifier,
  );
  const activeCardIdentifierType = useSelector(
    (state) => state.cardDataSliceReducer?.identifierType,
  );
  const clientDataReducer = useSelector((state) => state.clientDataReducer);
  // Find the matching product mapping
  const productMapping = productData?.data;
  const handleRetrieveCode = (productData, orderId) => {
    if (productData) {
      trackEvent("coupon_redeem", {
        currency: "INR",
        value: productData?.total,
        gift_card_value: productData?.denomination * productData?.quantity,
      });
      dispatch(onSaveDenoCard({ productData, orderId }));
      clientConfig?.otpRedeem
        ? navigate("/otp", {
          state: {
            orderId: orderId,
            denomination: productData?.denomination,
            productId: productData?.productId || productMapping?.id,
          },
        })
        : navigate("/order-detail", {
          state: {
            orderId: orderId,
            denomination: productData?.denomination,
            productId: productData?.productId || productMapping?.id,
          },
        });
    }
  };

  // Extract convenience fee % and GST %
  const convenienceFeePercent = Number(productMapping?.convenienceFee) || 0;
  const gstPercent = Number(productMapping?.gst) || 0;
  const customerdis = Number(productMapping?.customerDiscount) || 0;

  useEffect(() => {
    trackEvent("page_browse", {
      page_title: "order confirmation",
      page_url: window.location.href,
    });

    const prevRoute = sessionStorage.getItem("PREV_ROUTE") || "";

    const selectedCard = localStorage.getItem("RewardWidget");
    const cardData = cardListData?.clientConfigData?.cards?.find(
      (card) => card.cardId === selectedCard,
    );
    let rewardPoints = 0;
    if (cardData) {
      rewardPoints = Math.floor(
        (orderDetails?.totalPayableAmount / cardData.perRs) *
        cardData.standardPoints *
        (cardData.bonusPoints / cardData.standardPoints + 1),
      );
    }

    const orderItems = orderDetails?.orderItems || [];
    trackEvent("purchase", {
      page_type: "checkout_page",
      client_code: gaTrackingConfig.trackingContext.client_code,
      platform_code: gaTrackingConfig.trackingContext.platform_code,
      page_url: prevRoute.includes("/card?")
        ? window.location.origin + prevRoute.replace("/card?", "/giftcard?")
        : window.location.href,
      total_gift_card_points: orderDetails?.orderItems.reduce(
        (sum, it) =>
          sum + Number(it?.denomination || 0) * Number(it?.quantity || 0),
        0,
      ),

      card_name: selectedCard ? selectedCard : "NA",
      reward_points: rewardPoints,

      DefaultCard: cardData?.cardName || "NA",
      ecommerce: {
        value: orderDetails?.totalPayableAmount,
        currency: "INR",
        discount: orderDetails?.orderItems.reduce(
          (sum, item, idx) =>
            sum + (item.denomination || 0) * (item.quantity || 0),
          0
        ) - orderDetails?.totalPayableAmount,
        transaction_id: orderDetails?.orderId,
        shipping: productMapping?.convenienceFee || 0,

        items: orderItems.map((item) => {
          return {
            index:
              parseInt(sessionStorage.getItem("ga4_seletedProductIndex")) ||
              null,
            item_brand: orderDetails?.name,
            item_name: orderDetails?.name,
            discount: (item.denomination * item.quantity) - item.discountAmount,
            affiliation: gaTrackingConfig.trackingContext.affiliation,
            item_category: "Giftcards",
            item_category2: productMapping?.clientCategoryName || "",
            item_image: getImageUrl(orderDetails?.cardImage) || defaultImage,
            price: Number(item?.you_pay),
            quantity: item?.quantity,
            gift_card_points: item?.denomination,
            item_id: orderDetails?.sku,
            item_url: prevRoute.includes("/card?")
              ? window.location.origin +
              prevRoute.replace("/card?", "/giftcard?")
              : window.location.href,
            DefaultCard: cardData?.cardName || "NA",
            item_list_name: sessionStorage.getItem("ga4_item_list_name") || "",
            item_list_id: sessionStorage.getItem("ga4_item_list_name") || "",
          };
        }),
      },
    });

    if (cardData?.show) {
      navigate("/");
    }
    dispatch(onShowThankYouReset());
  }, []);

  useEffect(() => {
    if (
      orderFailure
      || isWalletJourney
      || !loginV3Data?.memberIdentifier
      || !activeCardIdentifier
    ) return;

    const refreshCardBalance = async () => {
      const response = await callSwitchAccountApi({
        identifier: loginV3Data?.memberIdentifier,
        subIdentifier: activeCardIdentifier,
        identifierType: getIdentifierType(activeCardIdentifierType),
        isAccountSwitch: true,
        userSessionToken: sessionStorage.getItem("loginSessionToken"),
      });

      if (String(response?.errorCode) !== "200") return;

      const pointBalance = Math.floor(
        response?.response?.response?.memberBalance?.pointBalance ?? 0,
      );
      dispatch(onSavePoints({
        pointBalance,
        identifierType: activeCardIdentifierType,
        subIdentifier: activeCardIdentifier,
      }));
    };

    refreshCardBalance();
  }, [
    activeCardIdentifier,
    activeCardIdentifierType,
    dispatch,
    isWalletJourney,
    loginV3Data?.memberIdentifier,
    orderFailure,
  ]);

  useEffect(() => {
    if (
      !useNewOrderConfirmation ||
      orderFailure ||
      !orderDetails?.orderId ||
      !purchasedDenomination
    ) return;

    dispatch(
      onGetOrderCode({
        id: orderDetails.orderId,
        deno: purchasedDenomination,
        customerId: loginV3Data?.memberIdentifier,
      }),
    );
  }, [
    dispatch,
    orderDetails?.orderId,
    orderFailure,
    purchasedDenomination,
    useNewOrderConfirmation,
  ]);

  if (useNewOrderConfirmation) {
    return (
      <>
        <ScrollToTop />
        <ThankYouOrderDetails
          orderDetails={orderDetails}
          productData={productData}
          productMapping={productMapping}
          translation={translation}
          issuedVouchers={issuedVouchers}
          gcIdConfig={supplierGcIdConfig}
          voucherLoading={orderCodeData?.isGetLoading}
          informationSection={newOrderTncComponent}
          orderFailure={orderFailure}
          orderResponse={location?.state}
          showRedeemPointData={showRedeemPointData}
        />
      </>
    );
  }

  return (
    <>
      <ScrollToTop />
      {false ? (
        <Loader />
      ) : (
        <div className="bg-light-grey minhight2">
          <BackSections />
          <section className={`pt-16px pt-24px ${isMobile ? "" : "mr-tb"}`}>
            <div className="card-container p-2">
              <div className="row justify-content-center">
                <div className="col-md-4 col-12 order_confirm_leftbox">
                  {orderFailure ? (
                    <div className="order-failed-container">
                      <div className="order-failed-box">
                        <div className="order-failed-header bottom-b">
                          <div className="failed-warning-sz warning-color">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="40"
                              height="40"
                              viewBox="0 0 40 40"
                            >
                              <defs>
                                <mask id="warningMask">
                                  <rect width="40" height="40" fill="white" />
                                  <rect
                                    x="18"
                                    y="10"
                                    width="4"
                                    height="12"
                                    rx="2"
                                    fill="black"
                                  />
                                  <circle cx="20" cy="28" r="2" fill="black" />
                                </mask>
                              </defs>

                              <path
                                d="M29.414 0.586002C29.2286 0.399917 29.0082 0.252341 28.7655 0.151771C28.5229 0.0512003 28.2627 -0.000378898 28 0H12C11.7373 0 11.4771 0.0512003 11.2345 0.151771C10.9918 0.252341 10.7714 0.399917 10.586 0.586002L0.586002 10.586C0.399917 10.7714 0.252341 10.9918 0.151771 11.2345C0.0512003 11.4771 0 11.7373 0 12V28C0 28.532 0.21 29.04 0.586002 29.414L10.586 39.414C10.7714 39.6001 10.9918 39.7477 11.2345 39.8482C11.4771 39.9488 11.7373 40 12 40H28C28.532 40 29.04 39.79 29.414 39.414L39.414 29.414C39.6001 29.2286 39.7477 29.0082 39.8482 28.7655C39.9488 28.5229 40 28.2627 40 28V12C40 11.7373 39.9488 11.4771 39.8482 11.2345C39.7477 10.9918 39.6001 10.7714 39.414 10.586L29.414 0.586002Z"
                                fill="var(--warning-bg)"
                                mask="url(#warningMask)"
                              />
                            </svg>
                          </div>
                          <div className="head-text">
                            <span className="head-text-1">
                              {translation?.order_failed}
                            </span>
                            <span className="head-subtext">
                              {translation?.gift_card_purchase}
                            </span>
                          </div>
                        </div>
                        <div className="contact-support-section1">
                          <Link to="/contact-us" className="contact-link">
                            {translation?.contactSupport}
                          </Link>
                        </div>
                      </div>
                      <div className="contact-support-section2">
                        <Link to="/contact-us" className="contact-link">
                          {translation?.failedContactSupport}
                          <i
                            className="fa fa-angle-right arrow-color"
                            aria-hidden="true"
                          ></i>
                        </Link>
                      </div>

                      <div className="order-cancel-box">
                        <span>{translation?.orderCancelled}</span>
                      </div>

                      {isMobile && (
                        <h4 className="order-label">
                          {translation?.your_order_text}
                        </h4>
                      )}
                    </div>
                  ) : (
                    <>
                      <div className="thanku-card">
                        <div className="bg-pink">
                          <div className="thankyoubox_top">
                            {orderFailure ? (
                              <i className="fa fa-times fail-icon"></i>
                            ) : (
                              <div className="badge-icon badge-check-color">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="44"
                                  height="44"
                                  viewBox="0 0 44 44"
                                  fill="none"
                                >
                                  <defs>
                                    <linearGradient
                                      id="badgeGradient"
                                      x1="0"
                                      y1="44"
                                      x2="44"
                                      y2="0"
                                      gradientUnits="userSpaceOnUse"
                                    >
                                      <stop
                                        offset="0%"
                                        stopColor="var(--badge-start)"
                                      />
                                      <stop
                                        offset="50%"
                                        stopColor="var(--badge-middle)"
                                      />
                                      <stop
                                        offset="100%"
                                        stopColor="var(--badge-end)"
                                      />
                                    </linearGradient>
                                  </defs>

                                  <path
                                    d="M17.5537 1.59995C20.057 -0.533348 23.7389 -0.53335 26.2422 1.59995L27.5953 2.75306C28.668 3.66723 30.0018 4.21969 31.4067 4.33181L33.1789 4.47323C36.4575 4.73486 39.0609 7.33832 39.3225 10.6169L39.464 12.3891C39.5761 13.794 40.1285 15.1278 41.0427 16.2005L42.1958 17.5536C44.3291 20.0569 44.3291 23.7388 42.1958 26.2421L41.0427 27.5952C40.1286 28.6679 39.5761 30.0017 39.464 31.4066L39.3225 33.1788C39.0609 36.4573 36.4575 39.0608 33.1789 39.3224L31.4067 39.4638C30.0018 39.576 28.668 40.1284 27.5953 41.0426L26.2422 42.1957C23.7389 44.329 20.057 44.329 17.5537 42.1957L16.2006 41.0426C15.1279 40.1284 13.7941 39.576 12.3892 39.4638L10.617 39.3224C7.33844 39.0608 4.73498 36.4573 4.47335 33.1788L4.33193 31.4066C4.21982 30.0017 3.66735 28.6679 2.75318 27.5952L1.60008 26.2421C-0.533226 23.7388 -0.533227 20.0569 1.60007 17.5536L2.75318 16.2005C3.66735 15.1278 4.21982 13.794 4.33193 12.3891L4.47335 10.6169C4.73498 7.33832 7.33844 4.73486 10.617 4.47323L12.3892 4.33181C13.7941 4.21969 15.1279 3.66723 16.2006 2.75306L17.5537 1.59995Z"
                                    fill="url(#badgeGradient)"
                                  />
                                </svg>

                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="19"
                                  height="14"
                                  viewBox="0 0 19 14"
                                  fill="none"
                                  className="check-icon"
                                >
                                  <path
                                    d="M17.5 1.5L6.5 12.5L1.5 7.5"
                                    stroke="var(--check-color)"
                                    strokeWidth="3"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </div>
                            )}
                            <div className="thankyoubox2">
                              <p className="onep">
                                {orderFailure
                                  ? translation.order_failure
                                  : translation?.thankYou}
                              </p>
                              {orderFailure ? (
                                translation.e_gift_card_purchase
                              ) : (
                                <p className="secondppp">
                                  {translation?.giftCardPurchaseSuccess}
                                </p>
                              )}
                            </div>
                          </div>
                          <hr className="hz-line" />
                          <div className="mb-2 thankyoumain_box">
                            <div className="thankyoubox3">
                              <p className="thank-ans">
                                {orderDetails?.orderId}
                              </p>
                              <p className="thank-qns">
                                {translation?.orderNumber}
                              </p>
                            </div>
                            <div className="thankyoubox3">
                              <p
                                className={`thank-ans ${!(showRedeemPointData && orderDetails?.burnPoints > 0) ||
                                  !(orderDetails?.totalPayableAmount > 0)
                                  ? "amount-only"
                                  : ""
                                  }`}
                              >
                                {showRedeemPointData && orderDetails?.burnPoints > 0 && (
                                  <>
                                    <img
                                      src={pointiconImage}
                                      alt="point"
                                      className="point-icon"
                                    />

                                    <span className="points-value">
                                      {Math.round(
                                        orderDetails?.burnPoints,
                                      ).toLocaleString("en-IN")}
                                    </span>

                                    <span className="points-text hide">
                                      Pts
                                    </span>

                                    {orderDetails?.totalPayableAmount > 0 && (
                                      <span className="plussign"> + </span>
                                    )}
                                  </>
                                )}

                                {orderDetails?.totalPayableAmount > 0 && (
                                  <span className="amount-right">
                                    ₹
                                    {formatPrice(
                                      orderDetails?.totalPayableAmount,
                                    )}
                                  </span>
                                )}
                              </p>

                              <p className="thank-qns text-end">
                                {translation?.orderAmount}
                              </p>
                            </div>
                            <div className="thankyoubox3 hide-bonus">
                              {showEarnPointData &&
                                orderDetails?.burnPoints <= 0 &&
                                parseInt(orderDetails?.earnPoints) > 0 && (
                                  <>
                                    <p className="thank-ans bold">
                                      {orderDetails?.burnPoints <= 0
                                        ? parseInt(orderDetails?.earnPoints) > 0
                                          ? `${orderDetails?.earnPoints} Pts`
                                          : `0 Pts`
                                        : `0 Pts`}
                                    </p>

                                    <span className="thank-qns">
                                      {translation?.bonusPoints}{" "}
                                    </span>
                                    <p className="thank-qns">
                                      {translation?.earned}
                                    </p>
                                  </>
                                )}
                            </div>
                          </div>
                          {showEarnedPoints && (
                            <>
                              <hr className="hz-line earned-divider d-none" />
                              <div className="earned-points-row d-none">
                                <span className="earned-points-label">
                                  {translation?.youEarned || "You Earned"}
                                </span>
                                <span className="earned-points-total">
                                  <img
                                    src={pointiconImage}
                                    alt=""
                                    aria-hidden="true"
                                    className="earned-point-icon"
                                  />
                                  <span>
                                    {Math.round(earnedPoints).toLocaleString(
                                      "en-IN",
                                    )}
                                  </span>
                                </span>
                              </div>
                            </>
                          )}
                        </div>
                        <div className="thku-page-b thanku-card">
                          <div className="d-flex justify-content-between pb-md-1">
                            <div className="thankyoubox3">
                              <Link to="/">
                                <p className="keep-thank">
                                  <span className="keep-shopping-default">
                                    {translation?.keepShoppingEarnMore}
                                  </span>
                                  <span className="keep-shopping-cc d-none">
                                    {translation?.keepShoppingSaveMore ||
                                      "Keep shopping to save more!"}
                                  </span>
                                </p>
                              </Link>
                            </div>
                            <div className="thankyoubox3">
                              <p className="onep" onClick={() => navigate("/")}>
                                <i
                                  className="fa fa-angle-right arrow-color"
                                  aria-hidden="true"
                                ></i>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className={`loyo ${isMobile ? "bg-white" : "card-bg"}`}
                      >

                        <div className="sentOrderDetails d-flex">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="100"
                            height="100"
                            viewBox="10 0 50 54"
                            role="img"
                            aria-label="information icon"
                          >
                            {" "}
                            <circle
                              cx="32.5"
                              cy="27"
                              r="16.5"
                              fill="none"
                              stroke="var(--egiftcard-icon-color)"
                              stroke-width="3"
                            />{" "}
                            <rect
                              x="31"
                              y="25"
                              width="3"
                              height="10"
                              rx="2.5"
                              ry="2.5"
                              fill="var(--egiftcard-icon-color)"
                            />{" "}
                            <circle
                              cx="32.5"
                              cy="20"
                              r="1.5"
                              fill="var(--egiftcard-icon-color)"
                            />{" "}
                          </svg>

                          <p className="dis-thank">

                            {orderFailure
                              ? translation?.orderCancelled
                              : translation?.orderDetailsMessage}
                          </p>
                        </div>
                      </div>

                    </>
                  )}
                  {!isMobile && tncComponent}
                </div>

                <div className="col-lg-4 col-12 mt-md-0 mrt-2 card-value">
                  <div className="side-newthank mb-0 img-padd">
                    <div className="d-flex w-100 h-100 justify-content-center">
                      <Link>
                        <div className="w-100 order_confirmation_img_div">
                          <img
                            className="order_confirmation_img"
                            alt="card-image"
                            src={
                              getImageUrl(orderDetails?.cardImage) ||
                              defaultImage
                            }
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = defaultImage;
                            }}
                          />
                        </div>
                      </Link>
                    </div>
                  </div>
                  <div className="card card_main_box mt-3">
                    <div className="card-body amazonPay_e_Gift_Card">
                      <div className="container pt-2">
                        <h5 className="card-title">{orderDetails?.cardName}</h5>
                        <div className="row header-row custom-inner-border">
                          <div
                            className={` ${clientInfo?.otpConfig === 1 ? "col-3" : "col-4 "
                              }  t_head py-2 text-center`}
                          >
                            <span>{translation?.value}</span>
                          </div>
                          <div
                            className={` ${clientInfo?.otpConfig === 1 ? "col-2" : "col-4"
                              }  t_head py-2 text-center`}
                          >
                            <span>{translation?.quantity}</span>
                          </div>
                          <div
                            className={` ${clientInfo?.otpConfig === 1 ? "col-3" : "col-4"
                              }  t_head py-2 text-center`}
                          >
                            <span>{translation?.youPaid}</span>
                          </div>
                          {clientInfo?.otpConfig === 1 ? (
                            <div
                              className={` ${clientInfo?.otpConfig === 1 ? "col-4" : "col-4"
                                } t_head py-2 text-center`}
                            >
                              <span>{translation?.code}</span>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                        {orderDetails?.orderItems?.map((card, index) =>
                          card?.quantity > 0 ? (
                            <div
                              className="row card-row custom-inner-border"
                              key={index}
                            >
                              <div
                                className={`${clientInfo?.otpConfig === 1
                                  ? "col-3"
                                  : "col-4"
                                  }  t_body py-2 text-center tabledata`}
                              >
                                ₹{formatPrice(card?.denomination)}
                              </div>
                              <div
                                className={`${clientInfo?.otpConfig === 1
                                  ? "col-2"
                                  : "col-4"
                                  } t_body py-2 text-center tabledata`}
                              >
                                {card?.quantity}
                              </div>{" "}
                              <div
                                className={`${clientInfo?.otpConfig === 1
                                  ? "col-3"
                                  : "col-4"
                                  }  t_body py-2 text-center tabledata`}
                              >
                                ₹{formatPrice(card?.total)}
                              </div>
                              {clientInfo?.otpConfig === 1 ? (
                                <div
                                  className={`${clientInfo?.otpConfig === 1
                                    ? "col-4"
                                    : "col-4"
                                    } t_body py-2 tabledata get-code-wrapper`}
                                >
                                  <button
                                    className={`get-code-btn ${orderFailure ? "disabled-btn" : ""
                                      }`}
                                    disabled={orderFailure}
                                    onClick={() =>
                                      handleRetrieveCode(
                                        card,
                                        orderDetails?.orderId,
                                      )
                                    }
                                  >
                                    {translation?.getCode}
                                  </button>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          ) : (
                            <></>
                          ),
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="card card_main_box mt-3 bg-white total-am-bg">
                    <div className="card-body">
                      {(() => {
                        let totalDenomination = 0;
                        let totalQuantity = 0;
                        let basePayableAmount = 0;
                        let convenienceFeeAmount = 0;
                        let gstAmount = 0;

                        const orderItems = orderDetails?.orderItems || [];

                        orderItems.forEach((item) => {
                          const qty = item.quantity || 0;
                          const denomination = item.denomination || 0;
                          const youPay = item.you_pay || 0;

                          totalDenomination += denomination * qty;
                          totalQuantity += qty;
                          basePayableAmount += youPay * qty;

                          const convFeePerItem =
                            (youPay * convenienceFeePercent) / 100;
                          convenienceFeeAmount += convFeePerItem * qty;

                          const gstPerItem =
                            (convFeePerItem * gstPercent) / 100;
                          gstAmount += gstPerItem * qty;
                        });
                        const totalDiscount =
                          (totalDenomination * customerdis) / 100;

                        //setTotalDiscount(totalDiscount);
                        const totalPayableAmount =
                          totalDenomination -
                          totalDiscount +
                          convenienceFeeAmount +
                          gstAmount;

                        return (
                          <>
                            {/* Total Giftcards */}
                            <div className="d-flex justify-content-between jlkk pb-2">
                              <div className="mr-4 lsss2">
                                {totalQuantity} {translation?.giftCard}
                                {totalQuantity > 1 ? "s" : ""}
                              </div>
                              <div className="lsss3">
                                ₹{totalDenomination.toLocaleString()}
                              </div>
                            </div>

                            {customerdis > 0 && (
                              <div className="d-flex justify-content-between jlkk pb-2">
                                <div className="mr-4 lsss2">
                                  {translation?.discount}
                                </div>
                                <div className="lsss3 discount-minus">
                                  ₹{formatPrice(totalDiscount)}
                                </div>
                              </div>
                            )}

                            {/* Convenience Fee + GST */}
                            {(convenienceFeeAmount > 0 || gstAmount > 0) && (
                              <div className="d-flex justify-content-between jlkk pb-2">
                                <div className="mr-4 lsss2">
                                  {convenienceFeeAmount > 0 && (
                                    <>
                                      <span className="d-block">
                                        {translation?.convenience_fe}
                                      </span>
                                      <span>{convenienceFeePercent}%</span>
                                    </>
                                  )}
                                  {gstAmount > 0 && (
                                    <span>{translation?.plus_gst}</span>
                                  )}
                                </div>
                                <div className="lsss3">
                                  ₹
                                  {formatPrice(
                                    convenienceFeeAmount + gstAmount,
                                  )}
                                </div>
                              </div>
                            )}

                            {/* Total Amount */}
                            <div className="d-flex justify-content-between jlkk">
                              <div className="mr-4 lsss3 lssss4">
                                {translation?.totalAmount}
                              </div>
                              <div className="lsss3">
                                ₹{formatPrice(totalPayableAmount)}
                              </div>
                            </div>
                          </>
                        );
                      })()}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {isMobile && tncComponent}
          </section >
        </div >
      )}
    </>
  );
};

export default OrderConfirmation;